import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useTranslation } from "react-i18next";

import {
    GET,
    newFetch
} from '../../helpers/fetch'

import ProfileInfo from '../../components/UserProfile/ProfileInfo'
import ProfileDetail from '../../components/UserProfile/ProfileDetail'
import PageShell from "../../components/UI/PageShell";

const UserProfile = ({ history }) => {
    const { t } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user'))
    const [associate, setAssociate] = useState(null)

    const fetchUser = async () => {
        let api_path = '/associate/aboutme'
        let response = await newFetch(GET, api_path)
        
        response.success && setAssociate(response.data)
    }

    useEffect(() => {
        if (user) {
            fetchUser()
        }
    }, [])

    return (
        <PageShell
          title={t("Profile")}
          eyebrow="Personal record"
          description="Review the personal and employment information connected to your account."
          backTo="/setting"
          actions={
            <button type="button" className="btn btn-design btn-brand" onClick={() => history.push('/profile/edit')}>
              <i className="fas fa-pen mr-2" aria-hidden="true" />
              {t('Edit Profile')}
            </button>
          }
        >
            {
                associate && <React.Fragment>
                    <ProfileInfo user={associate} />
                    <ProfileDetail user={associate} t={t} />
                </React.Fragment>
            }
        </PageShell>
    )
}

export default withRouter(UserProfile)
